import styled, { keyframes } from "styled-components";
import Animate from "./Animate";

const fadeInDown = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`;

const FadeDownWrap = styled(Animate)`
    & {
      opacity: 0;
    }

    &.fadeDown{
        animation:${fadeInDown} 0.5s forwards;
    }
`;

FadeDownWrap.defaultProps = {
    effectClassName: "fadeDown"
};

export default FadeDownWrap;